const en = {
  nav: {
    home: "Home",
    services: "Services",
    resources: "Resources",
    accompagnement: "Coaching",
    bookCall: "Book a call",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    svc: {
      reels: { name: "Reels & TikTok", desc: "Punchy short-form videos" },
      podcasts: { name: "Podcasts", desc: "Professional audio production" },
      events: { name: "Events", desc: "Event coverage" },
      formations: { name: "Online courses", desc: "Turnkey online courses" },
      ads: { name: "Ads", desc: "Meta, YouTube, TikTok ads" },
    },
    res: {
      cases: { name: "Case studies", desc: "Proven client results" },
      articles: { name: "Articles", desc: "Marketing guides and tips" },
      portfolio: { name: "Portfolio", desc: "Our video work" },
    },
  },
  hero: {
    eyebrow: "The creative agency trusted by ambitious entrepreneurs",
    title1: "A growth partner",
    title2: "building",
    titleEm: "predictable systems.",
    subtitle:
      "We build systems combining organic content creation with the power of paid advertising.",
    cta: "Book a free call",
  },
  services: {
    title1: "We scale your business with ",
    titleEm: "social media",
    intro:
      "Generate awareness. Convert leads. Drive revenue. Guaranteed.",
    items: [
      {
        title: "Identify bottlenecks",
        description:
          "We audit your business to see where your biggest opportunities are. This gives us the foundation for a custom-tailored strategy for your business.",
      },
      {
        title: "Build your marketing system",
        description:
          "We build scalable systems for social media, performance marketing, and organic business growth so you can scale predictably.",
      },
      {
        title: "Launch, test & scale",
        description:
          "We launch campaigns, test variations, and continuously optimize performance, doubling down on what drives views, engagement, and conversions so growth compounds over time.",
      },
      {
        title: "Guaranteed growth",
        description:
          "You get full transparency into performance to ensure targets are met. All backed by our performance guarantee.",
      },
    ],
  },
  portfolio: {
    badge: "Our expertise",
    title1: "From ideation to ",
    titleEm: "distribution",
    intro:
      "We support you from the first brainstorm to the final publication, with one mission: create content that attracts, engages… and converts.",
    tagline: "Strategy. Creation. Distribution. Optimization.",
    cta: "See our work",
    categories: {
      reels: "Reels",
      podcasts: "Podcasts",
      events: "Events",
      formations: "Online courses",
      ads: "Ads",
    },
    content: {
      reels: {
        title: "Reels",
        description:
          "At Agence 8020, we master the art of short videos that grab attention from the first seconds. Designed for social media, our vertical videos tell your story with impact and authenticity, while maximizing reach and engagement.",
        highlight:
          "In seconds, you deliver the right message to the right audience on the right platforms.",
      },
      podcasts: {
        title: "Podcasts",
        description:
          "In a world where every second counts, podcasts offer a powerful way to share meaningful stories and ideas. At Agence 8020, we create short, engaging and impactful audio experiences designed to captivate your audience.",
        highlight:
          "Our team blends strategy and creative storytelling to produce podcasts that inform, inspire and build lasting connections with your listeners.",
      },
      events: {
        title: "Events",
        description:
          "Every event deserves to be told with emotion and authenticity. At Agence 8020, we capture the energy, key moments and interactions that make your event unique. From a dynamic recap to a promotional video or full coverage, our team adapts to your vision and environment.",
        highlight:
          "Our goal: turn your moments into memorable stories that keep shining long after the event ends.",
      },
      formations: {
        title: "Online courses",
        description:
          "Turn your expertise into a growth tool. At Agence 8020, we help you design, structure and produce your online courses with clarity and impact. Our videos make your teaching captivating and accessible while reflecting your professionalism.",
        highlight:
          "Whether you want to shoot in our studio or your own environment, we support you at every step to deliver a smooth, engaging and human learning experience.",
      },
      ads: {
        title: "Ads",
        description:
          "Beyond organic content, we produce high-performing video ads for platforms like Meta (Facebook/Instagram), YouTube and TikTok. Our approach combines strategy, storytelling and ad optimization.",
        highlight:
          "We can handle ideation, production and distribution of your campaigns based on your visibility or conversion goals.",
      },
    },
  },
  process: {
    badge: "We launch fast",
    title1: "From first contact to ",
    titleEm: "results",
    intro1: "In a world where everything moves fast, your content must move even faster.",
    intro2:
      "Our process is built to go from idea to published content in record time. No endless meetings, no dragging deadlines. Just content that performs.",
    estimated: "Estimated time",
    ctaPrefix: "Ready to start? ",
    cta: "Book a call",
    milestoneEyebrow: "Go live",
    milestoneTitle1: "Launch in ",
    milestoneTitleEm: "7 days",
    milestoneDesc:
      "One week after the first call, your system is running: content in production, campaigns live, conversion in place. No six-month timelines, no excuses.",
    steps: [
      {
        title: "Discovery call",
        description:
          "We get to know each other. We listen to your goals and vision, and determine if there's a fit.",
        duration: "1h",
      },
      {
        title: "Strategy",
        description:
          "We do a deep dive into your brand, audience and market to build a tailored strategy.",
        duration: "2 days",
      },
      {
        title: "Creation & Production",
        description:
          "Structured shoots, dynamic editing and ads that perform. Content that stops the scroll.",
        duration: "5 days",
      },
      {
        title: "Launch",
        description:
          "Strategic publishing on your platforms at optimal times to maximize reach.",
        duration: "Immediate",
      },
      {
        title: "Optimization",
        description:
          "Performance analysis, adjustments and iteration for ever-better results.",
        duration: "Monthly",
      },
    ],
  },
  results: {
    badge: "Our results",
    title1: "Numbers that ",
    titleEm: "speak",
    intro: "Our expertise translates into concrete results for our clients",
    stats: [
      { label: "Views generated", description: "Across social media" },
      { label: "Happy clients", description: "Who trust us" },
      { label: "Videos produced", description: "Content created for our clients" },
      { label: "Average ROI", description: "Return on investment" },
    ],
  },
  testimonials: {
    title1: "What our clients ",
    titleEm: "think",
    intro:
      "Discover what our clients think about their experience with us. Authentic reviews, real stories and honest feedback.",
  },
  partners: { title: "Our partners" },
  faq: {
    title1: "Frequently asked questions ",
    titleEm: "(FAQ)",
    items: [
      {
        question: "What services do you offer?",
        answer: `We offer end-to-end support in video content creation and distribution strategy.

Our main services include:
• Vertical videos for social media
• Podcasts, in studio or on location
• Event coverage and capture
• Online courses
• Performance-driven video ads

In short, we create content that attracts, engages and converts — whether you're building your brand, generating clients or inspiring your community.`,
      },
      {
        question: "How much does a mandate with Agence 8020 cost?",
        answer: `Our mandates are tailored to each client based on their needs, goals and project scope. We work mainly with monthly retainers that include strategy, content creation and distribution.

👉 During our first call, we figure out together what will have the most impact for you.`,
      },
      {
        question: "Do you only do video?",
        answer: `Video is at the core of our expertise, but our support goes further. We help our clients build a complete content strategy: publishing structure, brand positioning, ideation and social media optimization.`,
      },
      {
        question: "Can we shoot somewhere other than your studio?",
        answer: `Absolutely.

We have a professional studio in Mascouche, but our team travels across Quebec to capture content in your environment or at events.`,
      },
      {
        question: "How long does a project take before being published?",
        answer: `It depends on the format and number of deliverables, but on average a full production (from capture to delivery) takes 7 to 14 business days.

For monthly-retainer clients, a clear shooting and publishing calendar is set from the start.`,
      },
      {
        question: "Do you also do advertising?",
        answer: `Yes.

In addition to organic content creation, we produce high-performing video ads for platforms like Meta (Facebook/Instagram), YouTube and TikTok.

Our approach combines strategy, storytelling and ad optimization to turn your videos into real acquisition tools.

We can handle ideation, production and distribution of your campaigns based on your visibility or conversion goals.`,
      },
    ],
  },
  contact: {
    title1: "Ready to take it to the ",
    titleEm: "next level?",
    intro:
      "<0>Book a free discovery call</0> to discuss your project and see if Agence 8020 is the right partner to help you reach your goals.",
    cta: "Book a free call",
    note: "30-minute call • 100% free",
  },
  footer: {
    tagline: "Marketing support for ambitious entrepreneurs and professionals in Quebec.",
    servicesTitle: "Services",
    guidesTitle: "Guides",
    followTitle: "Follow us",
    accompagnement: "Marketing coaching",
    ourServices: "Our services",
    pricing: "Pricing",
    guideB2B: "B2B content marketing",
    guideCreation: "B2B content creation",
    guideAgency: "B2B marketing agency",
    guideVideo: "B2B video marketing",
    allArticles: "All articles",
    privacy: "Privacy policy",
    rights: "All rights reserved.",
  },
  langToggle: { label: "Language", switchTo: "Passer en français" },
};
export default en;
